import { render } from "./Tree.vue?vue&type=template&id=c7c65d28"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=c7c65d28&lang=css"
script.render = render

export default script